import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsMediaAPI from "../../api/posts-media/api";

export function useCreatePostMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsMediaAPI.createPostMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch posts media list
      queryClient.invalidateQueries({ queryKey: ["posts-media"] });

      // If the media has a postId, invalidate that specific post's media
      if (variables.postId) {
        queryClient.invalidateQueries({
          queryKey: ["posts-media", "post", variables.postId],
        });
      }
    },
    onError: (error) => {
      console.error("Create post media failed:", error);
    },
  });
}
